// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/consumer/entity/v1/entity.proto (package securities.transactional.datafeed.consumer.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.HotlistType
 */
export const HotlistType = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.HotlistType",
  [
    {no: 0, name: "HOTLIST_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "HOTLIST_TYPE_TOP_GAINER", localName: "TOP_GAINER"},
    {no: 2, name: "HOTLIST_TYPE_TOP_LOSER", localName: "TOP_LOSER"},
    {no: 3, name: "HOTLIST_TYPE_MOST_ACTIVE", localName: "MOST_ACTIVE"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.BoardType
 */
export const BoardType = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.BoardType",
  [
    {no: 0, name: "BOARD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BOARD_TYPE_RG", localName: "RG"},
    {no: 2, name: "BOARD_TYPE_TN", localName: "TN"},
    {no: 3, name: "BOARD_TYPE_NG", localName: "NG"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.Source
 */
export const Source = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.Source",
  [
    {no: 0, name: "SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SOURCE_ITCH", localName: "ITCH"},
    {no: 2, name: "SOURCE_IMQ", localName: "IMQ"},
    {no: 3, name: "SOURCE_CRYPTO", localName: "CRYPTO"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.SuspendState
 */
export const SuspendState = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.SuspendState",
  [
    {no: 0, name: "SUSPEND_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUSPEND_STATE_UNSUSPENDED", localName: "UNSUSPENDED"},
    {no: 2, name: "SUSPEND_STATE_SUSPENDED", localName: "SUSPENDED"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.AuctionCrossType
 */
export const AuctionCrossType = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.AuctionCrossType",
  [
    {no: 0, name: "AUCTION_CROSS_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AUCTION_CROSS_TYPE_OPENING", localName: "OPENING"},
    {no: 2, name: "AUCTION_CROSS_TYPE_INTRADAY", localName: "INTRADAY"},
    {no: 3, name: "AUCTION_CROSS_TYPE_CLOSING", localName: "CLOSING"},
    {no: 4, name: "AUCTION_CROSS_TYPE_CALL", localName: "CALL"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.OrderType
 */
export const OrderType = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BID", localName: "BID"},
    {no: 2, name: "ORDER_TYPE_OFFER", localName: "OFFER"},
  ],
);

/**
 * @generated from enum securities.transactional.datafeed.consumer.entity.v1.OrderStatus
 */
export const OrderStatus = /*@__PURE__*/ proto3.makeEnum(
  "securities.transactional.datafeed.consumer.entity.v1.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ORDER_STATUS_PARTIAL_MATCH", localName: "PARTIAL_MATCH"},
    {no: 3, name: "ORDER_STATUS_FULL_MATCH", localName: "FULL_MATCH"},
    {no: 4, name: "ORDER_STATUS_AMEND", localName: "AMEND"},
    {no: 5, name: "ORDER_STATUS_WITHDRAW", localName: "WITHDRAW"},
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Change
 */
export const Change = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.BestOrder
 */
export const BestOrder = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.BestOrder",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Company
 */
export const Company = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Company",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol3", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sector", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "sub_sector", jsonName: "sub_sector", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "latest_price", jsonName: "latest_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "latest_numshare", jsonName: "latest_numshare", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "exchange", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "default_currency", jsonName: "default_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "tz", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "trade_type", jsonName: "trade_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "isin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "sedol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "tradable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "sector_name", jsonName: "sector_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "sub_sector_name", jsonName: "sub_sector_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "instrument", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "remarks_short", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "remarks_long", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "special_notation_codes", jsonName: "special_notation_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Sector
 */
export const Sector = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Sector",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "disabled", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "alias1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "alias2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "market_id", jsonName: "market_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "global_sector_id", jsonName: "global_sector_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "parent_name", jsonName: "parent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Hotlist
 */
export const Hotlist = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Hotlist",
  () => [
    { no: 1, name: "stocks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(HotlistType) },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Intraday
 */
export const Intraday = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Intraday",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "close", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "change", kind: "message", T: Change },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.LivePrice
 */
export const LivePrice = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.LivePrice",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastprice", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "high", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "low", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "frequency", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "frg_buy", jsonName: "frg_buy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "frg_sell", jsonName: "frg_sell", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "average", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "close", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "prev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "change", kind: "message", T: Change },
    { no: 16, name: "order_verb", jsonName: "order_verb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "is_index", jsonName: "is_index", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "match_number", jsonName: "match_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "board", kind: "enum", T: proto3.getEnumType(BoardType) },
    { no: 24, name: "source", kind: "enum", T: proto3.getEnumType(Source) },
    { no: 25, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Orderbook
 */
export const Orderbook = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Orderbook",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "enum", T: proto3.getEnumType(Source) },
    { no: 7, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
    { no: 8, name: "board", kind: "enum", T: proto3.getEnumType(BoardType) },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.IEPIEV
 */
export const IEPIEV = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.IEPIEV",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iep", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "iev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "auction_cross_type", jsonName: "auction_cross_type", kind: "enum", T: proto3.getEnumType(AuctionCrossType) },
    { no: 7, name: "best_bid", jsonName: "best_bid", kind: "message", T: BestOrder },
    { no: 8, name: "best_offer", jsonName: "best_offer", kind: "message", T: BestOrder },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.SwitchReset
 */
export const SwitchReset = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.SwitchReset",
  () => [
    { no: 1, name: "from", kind: "enum", T: proto3.getEnumType(Source) },
    { no: 2, name: "to", kind: "enum", T: proto3.getEnumType(Source) },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "datetime", jsonName: "date_time", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.CompanyTradingAction
 */
export const CompanyTradingAction = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.CompanyTradingAction",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "trading_state", jsonName: "trading_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
    { no: 10, name: "suspend_state", jsonName: "suspend_state", kind: "enum", T: proto3.getEnumType(SuspendState) },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.OrderDetail
 */
export const OrderDetail = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.OrderDetail",
  () => [
    { no: 1, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
    { no: 4, name: "order_type", jsonName: "order_type", kind: "enum", T: proto3.getEnumType(OrderType) },
    { no: 5, name: "order_status", jsonName: "order_status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 6, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "exchange_order_number", jsonName: "exchange_order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "total_quantity", jsonName: "total_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "open_quantity", jsonName: "open_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.AccountRegistration
 */
export const AccountRegistration = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.AccountRegistration",
  () => [
    { no: 1, name: "account_id", jsonName: "account_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "approved_by_cs", jsonName: "approved_by_cs", kind: "message", T: ApprovedByCS },
    { no: 3, name: "closed_date", jsonName: "closed_date", kind: "message", T: Timestamp },
    { no: 4, name: "completed_date", jsonName: "completed_date", kind: "message", T: Timestamp },
    { no: 5, name: "created_date", jsonName: "created_date", kind: "message", T: Timestamp },
    { no: 8, name: "partner", kind: "message", T: Partner },
    { no: 9, name: "securities_id", jsonName: "securities_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "status_kyc", jsonName: "status_kyc", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.ApprovedByCS
 */
export const ApprovedByCS = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.ApprovedByCS",
  () => [
    { no: 1, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "actor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "actor_username", jsonName: "actor_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "updated_date", jsonName: "updated_date", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.Partner
 */
export const Partner = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.Partner",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.OrderCancel
 */
export const OrderCancel = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.OrderCancel",
  () => [
    { no: 1, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "order_number", jsonName: "order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "order_verb", jsonName: "order_verb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "order_book_id", jsonName: "order_book_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "formatted_time", jsonName: "formatted_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "exchange_order_number", jsonName: "exchange_order_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "board_type", jsonName: "board_type", kind: "enum", T: proto3.getEnumType(BoardType) },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.consumer.entity.v1.IndexMember
 */
export const IndexMember = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.consumer.entity.v1.IndexMember",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "index_code", jsonName: "index_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "switch_reset", jsonName: "switch_reset", kind: "message", T: SwitchReset },
  ],
);

